import { render } from "./Thesis.vue?vue&type=template&id=56dfe7a7"
import script from "./Thesis.vue?vue&type=script&lang=js"
export * from "./Thesis.vue?vue&type=script&lang=js"

import exportComponent from "/opt/cah/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__